import { useFilePreview } from "@jugl-web/domain-resources/files/providers/FilePreviewProvider";
import mime from "mime";
import { useCallback } from "react";

export type UseCommentAttachmentPreviewOptions = {
  onDownload?: (url: string, name: string) => void;
};

const getAttachmentName = (attachmentUrl: string): string =>
  decodeURIComponent(attachmentUrl.split("/").pop()?.split("?")[0] || "file");

export const useCommentAttachmentPreview = (
  options?: UseCommentAttachmentPreviewOptions
) => {
  const { previewFile, previewFiles } = useFilePreview();
  const { onDownload } = options ?? {};

  const handleDownload = useCallback(
    (attachmentUrl: string) => {
      if (onDownload) {
        const name = getAttachmentName(attachmentUrl);

        onDownload(attachmentUrl, name);
        return;
      }

      window.open(attachmentUrl, "_blank");
    },
    [onDownload]
  );

  const handleAttachmentClick = useCallback(
    (url: string, allUrls: string[]) => {
      const configs = allUrls.map((attachmentUrl) => {
        const name = getAttachmentName(attachmentUrl);

        return {
          url: attachmentUrl,
          name,
          mimeType: mime.getType(attachmentUrl) || "application/octet-stream",
          onDownload: () => handleDownload(attachmentUrl),
        };
      });

      if (configs.length === 1) {
        previewFile(configs[0]);
        return;
      }

      previewFiles(configs, url);
    },
    [handleDownload, previewFile, previewFiles]
  );

  return { handleAttachmentClick, handleDownload };
};
